import { request } from '@/shared/api/request'

export const adjustmentConfirmXml = (data) => {
	return request({ url: 'contract/labor/jur/contractAdjustmentConfirmation/xml', method: 'POST', data })
}
export const adjustmentConfirm = (payload) => {
	return request({ url: 'contract/labor/contractAdjustment/send', method: 'POST', data: payload })
}
